import styled from 'styled-components';
import { Download } from '@styled-icons/boxicons-regular/Download';
import { Cart3 } from '@styled-icons/bootstrap';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div<{ disabled: boolean }>`
  ${({ disabled }) =>
    disabled &&
    `
    opacity: var(--opacity-level-medium);

  `};
`;

export const DownloadIcon = styled(Download)`
  width: 1rem;
  margin-right: 0.5rem;
`;

export const CartIcon = styled(Cart3)`
  width: 1rem;
  margin-right: 0.5rem;
`;

export const OrderInfos = styled.div`
  p {
    margin-bottom: 1rem;
    font-size: 14px;
    line-height: 22px;
    font-family: 'Work Sans';
    span {
      font-weight: bold;
    }
  }
`;
